// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3WDNm","left":"InfoRow_left__2MydR"};